import "./topBox.scss";
import googleLogo from "../../images/google-logo.svg";
import logo from "../../images/logo.svg";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";


const TopBox = () => {

    const [testimonyData, setTestimonyData] = useState();
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getTestimonials = async () => {

            try {
                const response = await axiosPrivate.get('/testimonials', {
                    signal: controller.signal
                });

                console.log(response.data);

                isMounted && setTestimonyData(response.data);
            } catch (error) {
                console.error("Error fetching testimonials:", error);
                
                
                if (error?.response?.status === 401) {
                    navigate('/cpanel/login', { state: { from: location }, replace: true });
                }
            }
        }
        getTestimonials();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [axiosPrivate, navigate, location]);


    return (
        <div className="topBox">
            <h1>Top Testimonies</h1>
            <div className="list">
                {
                    testimonyData?.length ? (
                        testimonyData.map(testimony => (
                            <div className="listItem" key={testimony.id}>
                                <div className="testimony">

                                    <img src={testimony.testimonyFrom === "Google" ? googleLogo : logo} alt="" />

                                    <div className="testimonyText">
                                        <span>{testimony.customerName}</span>
                                        <p>"{testimony.comments}"</p>
                                    </div>

                                </div>
                                <span className="testimonyDate">{testimony.testimonyDate}
                                </span>
                            </div>
                        ))
                    ) : (<p>No testimonies to display</p>)


                }
            </div>
        </div>
    )
}

export default TopBox